import { Collapse } from "element-ui";

export default {
   props: {
      peizhi:'',
     
    }
    ,
    data() {
      return {
        
        options: [],
        value: '',
        tableData: [],
        search: '',
        sort:'',
        sort_huodong:'',
        sort1:'',
        offset:0,
        length:999,
        project_id:'',
        task_id:'',
        id:'',
        dialogVisible:false,
        dialogVisible1:false,
        dialogVisible2:false,
        outline:'',
        gridData:[],
        activitied:[],
        activitie_id:'',
        task_name_tishi:'',
        task_name1: '',//修改页面变量
        task_desc1: '',//修改页面变量
        task_name: '',
        task_desc: '',  
        task_sort: '',
        task_start_stydy_time:[],//阶段时间
        task_start_stydy_time1:[]//阶段时间编辑变量
      }
    },
    methods: {
       //判断整数
       isInteger(obj) {
        return obj%1 === 0
       },
        //确认关闭提示
       handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      //修改提示
      upbeat1(index, row){
          this.task_id=row.task_id
          this.task_name1=row.task_name
          this.task_desc1=row.task_desc
          this.task_start_stydy_time1[0] = row.task_start_study_time
          this.task_start_stydy_time1[1] = row.task_end_study_time
          this.id=row.id
          this.dialogVisible=true
          this.sort1=row.sort
      },
      //确定修改
      upbeat(){
          let text = "不能为空！"

          if(this.task_desc1==''){
            text = "任务描述_" +text;
          }

          if(this.sort1==''){
            text = "任务排序_" +text;
          }

          if(this.task_start_stydy_time1.length == 0 ){
            text = "阶段时间" +text;
          }

          if(this.task_name1==''){
            text = "任务名称_" +text;
          }
         
          if(this.sort1!='' && this.task_desc1!='' && this.task_name1!='' && this.task_start_stydy_time1.length != 0 ){
            this.$post('tasks/edit', {
              id:this.task_id,
              name:this.task_name1,
              desc:this.task_desc1,
              start_date_time : this.task_start_stydy_time1[0],
              end_date_time : this.task_start_stydy_time1[1],
              token: this.$store.state.authority_management,
            })
            if(this.isInteger(this.sort1)){
                this.$post('project_tasks/edit', {
                          id:this.id,
                          sort:this.sort1,
                          task_id:this.task_id,
                          token: this.$store.state.authority_management,
                }).then(res => {
                  if(res.data.status=='success'){
                    this.getxiangmurenwu()
                    this.success("修改成功！")
                    this.dialogVisible=false
                    this.getoutline(); //刷新项目大纲
                  }else{
                    this.tishi("修改失败！")
                  }
                  this.task_start_stydy_time1 = []
                })
            }else{
              this.tishi("修改失败,序号必须是整数！")
            }
          }else{
            this.tishi(text)
          }
         
      },
          //删除
       Delete1(index,row) {
        this.id=row.id
        
        this.$confirm('此操作将永久删除该任务, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.Delete()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
     
      Delete() {
      
            this.$post('project_tasks/delete', {
                      id:this.id,
                      // project_id:this.project_id,
                   token: this.$store.state.authority_management,
            }).then(res => {
              if(res.data.status=='success'){
                this.success("删除成功！")
                this.getxiangmurenwu()
                this.getoutline(); //刷新项目大纲
              }else{
                this.tishi("删除失败！")
              }
              
            })
           
      },
   
      // 获取项目已添加任务列表
      getxiangmurenwu(){
        if(this.project_id){
            this.$post('project_tasks/search_no_activity', {
                      offset:this.offset,  
                      length:this.length,
                    token: this.$store.state.authority_management,
                      project_id: this.project_id,
            }).then(res => {
              this.tableData = res.data.result.data
            })
        }
      },
         // 提示消息
     tishi(text) {
      this.$message.error(text);
    },
    // 成功消息
    success(text) {
          this.$message({
            message: text,
            type: 'success'
          });
        },
      // 添加项目任务
      create(){
        let text ='请输入'

        if(!this.task_name){
          text += '_任务名称'
        }
        if(!this.task_sort){
          text += '_序号'
        }
        if(this.task_start_stydy_time.length == 0 ){
          text += '阶段时间'
        }
        if(!this.task_desc ){
          text += '_描述'
        }
 
        // console.log(this.task_start_stydy_time)
        if(this.task_name && this.task_sort && this.task_desc && this.task_start_stydy_time.length != 0 ){
              this.$post('project_tasks/create', {
                        token: this.$store.state.authority_management,
                        project_id: this.project_id,
                        task_name: this.task_name,
                        task_desc: this.task_desc,  
                        task_start_study_time : this.task_start_stydy_time[0],
                        task_end_study_time : this.task_start_stydy_time[1],
                        project_tasks_sort: this.task_sort,
              }).then(res => {
                  if(res.data.status=='success'){
                    this.getxiangmurenwu()
                    this.success("添加项目任务成功！")
                    this.getoutline(); //刷新项目大纲
                    this.task_name = ''
                    this.task_desc = ''
                    this.task_sort = ''
                  }else{
                    this.tishi("添加项目任务失败！")
                  }
                  this.task_start_stydy_time = []
              })

        }else{
          this.tishi(text)
        }
      },
     
      //查询项目大纲
      getoutline(){
        this.$post('project_tasks/search_group_by_task', {
            token: this.$store.state.authority_management,
            offset:0 , 
            length: 100, 
            project_id:  this.project_id
        }).then(res => {
            this.outline = res.data.result.data.map((res)=>{
                for(let i=0;i<res.task_activities.length;i++){
                    res.task_activities[i].resources = JSON.parse(res.task_activities[i].resources)
                      // console.log(res.task_activities[i].resources) 
                }  
                return res
            })
            // console.log('项目大纲',this.outline )
        })
      },
      // 查询所有活动
      gettask_activities(){
          this.$post('activities/search',{
            token:this.$store.state.authority_management,
            offset:0,
            length:999999
          }).then(res=>{
            this.activitied=res.data.result.data
          })
      },
      // 获取任务已添加的活动
      getactivities(){
        this.$post('task_activities/search',{
          token:this.$store.state.authority_management,
          offset:0,
          length:999999,
          task_id:this.task_id
        }).then(res=>{
          this.gridData =res.data.result.data;
          // console.log('获取任务已添加的活动',this.gridData)
        })
      },
      //添加活动弹出框
      addhuodong(m){
        this.task_id = m.task_id
        this.getactivities()
        this.dialogVisible2= true;  
      },
      // 删除任务活动
      deleteTask_activities(res){
        this.$post('task_activities/delete',{
          token:this.$store.state.authority_management,
          id:res.id
        }).then(res=>{
          this.getactivities()//刷新任务活动列表
          this.getoutline(); //刷新项目大纲
        })
      },
      //添加活动
    pushitem(){
      let text = '请输入'

      if(this.pdhd()){
        this.tishi("该活动已存在，不能重复添加！")
        return
      }
      if(!this.activitie_id){
          text += '_活动名称'
      }
      if(!this.sort_huodong){
        text += '_排序序号'
    }
      if(this.activitie_id && this.sort_huodong){
        this.$post('task_activities/create_one',{
          token:this.$store.state.authority_management,
          task_id:this.task_id,
          activity_id:this.activitie_id,
          sort:this.sort_huodong
        }).then(res=>{
          if(res.data.status=='success'){
            this.success("添加任务活动成功！")
            this.getactivities()//刷新已添加活动列表
            this.getoutline(); //刷新项目大纲
          } else{
            this.tishi("添加失败！")
          }
        })
      }else{
        this.tishi(text)
      }
    },
    // 判断活动是否出重复添加
    pdhd(){
      for(let i=0;i<this.gridData.length;i++){
        if(this.gridData[i].activitie_id == this.activitie_id){
            return true
        }
      }
      return false
    }

  },


    created(){
       this.project_id = this.peizhi
       this.getxiangmurenwu();
       this.getoutline(); //查询项目大纲
       this.gettask_activities() // 查询所有活动


    }
  }